import { useQuery } from '@tanstack/react-query'
import { useDebounced } from '@/hooks/use-debounced'
import type { LakeSearchResponse } from '@/services/api/lake'
import { lakeApi } from '@/services/api/lake'

export interface LakeSearchScope {
  label?: string | null
  storagePrefixes?: string[] | null
}

export function useLakeSearch(query: string, scope?: LakeSearchScope) {
  const debounced = useDebounced(query, 275)
  const enabled = debounced.trim().length >= 3

  return useQuery<LakeSearchResponse>({
    queryKey: ['lake-search', debounced, scope?.label ?? null, scope?.storagePrefixes ?? null],
    queryFn: () =>
      lakeApi.search({
        query: debounced,
        top_k: 8,
        per_page: 8,
        search_documents: true,
        search_chunks: true,
        label: scope?.label ?? null,
        storage_prefixes: scope?.storagePrefixes ?? null,
      }),
    enabled,
    staleTime: 30_000,
  })
}
